import { Navigate, Route, Routes } from 'react-router-dom';

import CustomSignIn from 'components/CustomSignIn/CustomSignIn';

import env, { EEnvs } from 'constants/env';

import { lazyWithRetry } from 'utils/lazy-with-retry';

import useAuthStateListener from 'hooks/useAuthStateListener';

const ResetPassword = lazyWithRetry(() => import('components/pages/ResetPassword/ResetPassword'));
const CustomConfirmSignUp = lazyWithRetry(() => import('components/CustomConfirmSignUp/CustomConfirmSignUp'));
const CustomForgotPassword = lazyWithRetry(() => import('components/CustomForgotPassword/CustomForgotPassword'));
const TermsAndConditionsModal = lazyWithRetry(() => import('components/PopUps/TermsAndConditionsModal'));
const ValidationPage = lazyWithRetry(() => import('components/pages/ValidationPage/ValidationPage'));
const ConfirmEmail = lazyWithRetry(() => import('components/pages/ConfirmEmail/ConfirmEmail'));
const Learn = lazyWithRetry(() => import('components/pages/Learn/Learn'));
const LinkingVerificationsPage = lazyWithRetry(
    () => import('components/pages/LinkingVerificationsPage/LinkingVerificationsPage'),
);
const SignUpPage = lazyWithRetry(() => import('components/pages/SignUpPage/SignUpPage'));

const GuestApp = () => {
    useAuthStateListener();
    return (
        <>
            <TermsAndConditionsModal />
            <Routes>
                <Route path="/validate" element={<ValidationPage />} />
                <Route path="/validate/:guid" element={<ValidationPage />} />
                <Route path="/reset_password" element={<ResetPassword />} />
                <Route path="/confirm_email" element={<ConfirmEmail />} />
                <Route path="/learn" element={<Learn />} />
                <Route path="/" element={<CustomSignIn />} />
                {env.REACT_APP_ENV === EEnvs.dev && <Route path="/signup" element={<SignUpPage />} />}
                <Route path="/forgot-password" element={<CustomForgotPassword />} />
                <Route path="/verification" element={<CustomConfirmSignUp />} />
                <Route path="/link/:code" element={<LinkingVerificationsPage />} />
                <Route path="/*" element={<Navigate to="/" />} />
            </Routes>
        </>
    );
};

export default GuestApp;
